import React from 'react';
import { BrowserRouter as Router, Routes, Route, Link, useLocation } from 'react-router-dom';
import { HashLink } from 'react-router-hash-link';
import './App.css';
import Home from './pages/Home';
import Accounting from './pages/Accounting';
import Registration from './pages/Registration';
import Tax from './pages/Tax';
import About from './pages/About';
import Contact from './pages/Contact';
import Admin from './pages/Admin';
import Gst from './pages/Gst';
import Advisory from './pages/Advisory';
import Financial from './pages/Financial';
import Cart from './pages/Cart';
import Checkout from './pages/Checkout';
import { CartProvider } from './context/CartContext';
import { SettingsProvider } from './context/SettingsContext';
import CartButton from './components/CartButton';
import IndiaFlag from './components/IndiaFlag';
import logo from './assets/logo.png';

// Add ScrollToTop component
function ScrollToTop() {
  const { pathname } = useLocation();

  React.useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

function App() {
  return (
    <SettingsProvider>
      <CartProvider>
        <Router>
          <div className="App">
            <ScrollToTop />
            <header className="App-header">
              <nav className="nav-bar">
                <Link to="/" className="company-logo">
                  <img src={logo} alt="RKube Services" className="logo" />
                  <span className="company-name">RKube Services</span>
                </Link>
                <div className="nav-links">
                  <HashLink smooth to="/#services">Services</HashLink>
                  <Link to="/about">About</Link>
                  <Link to="/contact">Contact</Link>
                  {/* <div className="flag-wrapper">
                    <IndiaFlag />
                  </div> */}
                  <CartButton />
                  {/* <Link to="/admin" className="admin-link">Admin</Link> */}
                </div>
              </nav>
            </header>

            <Routes>
              <Route path="/" element={<Home />} />
              <Route path="/accounting" element={<Accounting />} />
              <Route path="/registration" element={<Registration />} />
              <Route path="/tax" element={<Tax />} />
              <Route path="/gst" element={<Gst />} />
              <Route path="/advisory" element={<Advisory />} />
              <Route path="/financial" element={<Financial />} />
              <Route path="/about" element={<About />} />
              <Route path="/contact" element={<Contact />} />
              <Route path="/cart" element={<Cart />} />
              <Route path="/checkout" element={<Checkout />} />
              <Route path="/admin" element={<Admin />} />
            </Routes>

            <footer className="footer">
              <p>&copy; 2024 RKube Services. All rights reserved.</p>
            </footer>
          </div>
        </Router>
      </CartProvider>
    </SettingsProvider>
  );
}

export default App; 